import React from 'react';
import { connect } from 'react-redux';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import LibreLimits from 'apps/auth/components/profile/libreLimits/LibreLimits';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE } from 'apps/auth/constants/UrlConstants';
import { useExtra } from 'apps/auth/hooks/selectors';

const ProfileLibreLimitInfoPage = () => {
    const { profile_form: libre_limit } = useExtra();

    return (
        <CommonPage backUrl={AUTH_PROFILE} showChat={false}>
            {libre_limit && <LibreLimits />}
        </CommonPage>
    );
};
export default connect()(BasePage(ProfileLibreLimitInfoPage));
